import { TransformedLocaleConfig, LocaleName } from '../type';
const baseLocaleConfig = {
  name: 'zh-Hant',
  months: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
  monthsShort: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
  weekdays: ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'],
  weekdaysMin: ['日', '一', '二', '三', '四', '五', '六'],
  weekdaysShort: ['週日', '週一', '週二', '週三', '週四', '週五', '週六'],
  formats: {
    LT: 'HH:mm',
    LTS: 'HH:mm:ss',
    lt: 'Ah:mm',
    lts: 'Ah:mm:ss',
    L: 'YYYY/M/D',
    LL: 'YYYY年M月D日',
    'LL-D': 'YYYY年M月',
    'LL-Y': 'M月D日',
    LLL: 'YYYY年M月D日 HH:mm',
    'LLL-Y': 'M月D日 HH:mm',
    LLLL: 'YYYY年M月D日 dddd HH:mm',
    'LLLL-Y': 'dddd M月D日 HH:mm',
    l: 'YYYY/M/D',
    'l-Y': 'M/D',
    ll: 'YYYY年M月D日',
    'll-Y': 'M月D日',
    'll-D': 'YYYY年M月',
    lll: 'YYYY年M月D日 Ah:mm',
    'lll-Y': 'M月D日 Ah:mm',
    llll: 'YYYY年M月D日 ddd Ah:mm',
    'llll-Y': 'M月D日 ddd Ah:mm',
    'll-Y+w': 'M月D日 ddd',
    'LT+to': 'HH:mm（[GMT]Z）',
    'LLL+to': 'YYYY年M月D日 HH:mm（[GMT]Z）',
  },
  meridiem: { am: '上午', pm: '下午', AM: '上午', PM: '下午' },
  past: {
    y: { other: '%s 年前' },
    M: { other: '%s 個月前' },
    w: { other: '%s 週前' },
    d: { other: '%s 天前' },
    h: { other: '%s 小時前' },
    m: { other: '%s 分鐘前' },
    s: { other: '%s 秒前' },
  },
  future: {
    y: { other: '%s 年後' },
    M: { other: '%s 個月後' },
    w: { other: '%s 週後' },
    d: { other: '%s 天後' },
    h: { other: '%s 小時後' },
    m: { other: '%s 分鐘後' },
    s: { other: '%s 秒後' },
  },
  pastLong: {
    y: { other: '%s 年前' },
    M: { other: '%s 個月前' },
    w: { other: '%s 週前' },
    d: { other: '%s 天前' },
    h: { other: '%s 小時前' },
    m: { other: '%s 分鐘前' },
    s: { other: '%s 秒前' },
  },
  futureLong: {
    y: { other: '%s 年後' },
    M: { other: '%s 個月後' },
    w: { other: '%s 週後' },
    d: { other: '%s 天後' },
    h: { other: '%s 小時後' },
    m: { other: '%s 分鐘後' },
    s: { other: '%s 秒後' },
  },
  abbr: {
    y: { other: '%s年' },
    M: { other: '%s個月' },
    w: { other: '%s週' },
    d: { other: '%s天' },
    h: { other: '%s小時' },
    m: { other: '%s分鐘' },
    s: { other: '%s秒' },
  },
  full: {
    y: { other: '%s 年' },
    M: { other: '%s 個月' },
    w: { other: '%s 週' },
    d: { other: '%s 天' },
    h: { other: '%s 小時' },
    m: { other: '%s 分鐘' },
    s: { other: '%s 秒' },
  },
  justNow: '剛剛',
  yesterday: '昨天',
  today: '今天',
  tomorrow: '明天',
  weekStart: 1,
  timeRange: '%$1s – %$2s',
  timeZone: '%$1s %$2s',
  timePref: { 'Ah:mm': 'HH:mm' },
  timeRangeStyles: {
    yl: { start: 'YYYY年M月D日', end: 'YYYY年M月D日' },
    'yl-1': { start: 'M月D日', end: 'YYYY年M月D日' },
    ml: { start: 'M月D日', end: 'M月D日' },
    'ml-1': { start: 'YYYY年M月D日', end: 'D日' },
    dl: { start: 'M月D日', end: 'D日' },
    y: { start: 'YYYY年M月D日', end: 'YYYY年M月D日' },
    'y-1': { start: 'YYYY年M月D日', end: 'M月D日' },
    m: { start: 'M月D日', end: 'M月D日' },
    'm-1': { start: 'YYYY年M月D日', end: 'D日' },
    d: { start: 'M月D日', end: 'D日' },
    Y: { start: 'YYYY年M月D日ddd', end: 'YYYY年M月D日ddd' },
    'Y-1': { start: 'YYYY年M月D日ddd', end: 'M月D日ddd' },
    M: { start: 'M月D日ddd', end: 'M月D日ddd' },
    D: { start: 'M月D日ddd', end: 'M月D日ddd' },
    yt: { start: 'YYYY年M月D日 HH:mm', end: 'YYYY年M月D日 HH:mm' },
    mt: { start: 'M月D日 HH:mm', end: 'M月D日 HH:mm' },
    dt: { start: 'M月D日 HH:mm', end: 'M月D日 HH:mm' },
    t: { start: 'HH:mm', end: 'HH:mm' },
    'yt+to': { start: 'YYYY年M月D日 HH:mm', end: 'YYYY年M月D日 HH:mm（[GMT]Z）' },
    'mt+to': { start: 'M月D日 HH:mm', end: 'M月D日 HH:mm（[GMT]Z）' },
    'dt+to': { start: 'M月D日 HH:mm', end: 'M月D日 HH:mm（[GMT]Z）' },
    't+to': { start: 'HH:mm', end: 'HH:mm（[GMT]Z）' },
  },
};
const localeName: LocaleName = 'zh-Hant';
export const localeConfig: TransformedLocaleConfig = {
  ...baseLocaleConfig,
  name: localeName,
  ordinal: (number, period) => {
    switch (period) {
      case 'W':
        return `${number}週`;
      default:
        return `${number}日`;
    }
  },
  meridiem: (hour, _, isLowerCase = false): string => {
    if (hour < 12) {
      return isLowerCase ? '上午' : '上午';
    } else {
      return isLowerCase ? '下午' : '下午';
    }
  },
};
